import {Component, EventEmitter, OnInit, Input, Output} from '@angular/core';
import {ProductModel} from '../../models/product.model';

@Component({
  selector: 'app-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.css']
})

export class CarouselComponent implements OnInit  {
  @Input() model: ProductModel[];
  @Input() showFamily: Boolean = true;
  @Input() productModelId: string = '';
  @Input() origprodId: string = '';
  @Input() productLine: string;

  config: SwiperOptions = {
    nextButton: '.swiper-button-next',
    prevButton: '.swiper-button-prev',
    spaceBetween: 10,
    slidesPerView:  "auto",
    loop: false,
    slidesPerGroup: 1,
    centeredSlides: false,
    initialSlide: 0,
    simulateTouch: true,
    grabCursor: true ,
    mousewheelControl: true,
    mousewheelForceToAxis: true,
    keyboardControl:true,
  };

  ngOnInit() {
     
  }
}


// WEBPACK FOOTER //
// ./src/app/product-category/containers/carousel/carousel.component.ts